import React from "react";
import { useTranslation } from "react-i18next";
import review1 from "images/review1.png";
import review2 from "images/review2.png";

const testimonials = [
  {
    key: "asma",
    img: review2,
    stars: 5,
  },
  {
    key: "amina",
    img: review1,
    stars: 5,
  },
];

const Testimonials = () => {
  const { t } = useTranslation();

  const styles = {
    wrapper: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      padding: "60px 40px",
      fontFamily: "'Segoe UI', sans-serif",
      backgroundColor: "#fff",
    },
    leftColumn: {
      flex: "0 0 30%",
      paddingRight: "40px",
    },
    rightColumn: {
      display: "flex",
      gap: "30px",
      flex: "1",
    },
    heading: {
      fontSize: "2em",
      color: "#2d5934",
      marginBottom: "20px",
    },
    paragraph: {
      fontSize: "1em",
      color: "#555",
      lineHeight: "1.6",
    },
    card: {
      backgroundColor: "#f9f9f9",
      borderRadius: "12px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
      padding: "30px 20px",
      maxWidth: "300px",
      position: "relative",
    },
    avatar: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      objectFit: "cover",
      position: "absolute",
      top: "-25px",
      left: "calc(50% - 25px)",
      border: "3px solid white",
    },
    text: {
      fontSize: "1em",
      color: "#2d5934",
      marginBottom: "15px",
    },
    stars: {
      color: "#2d5934",
      fontSize: "1.2em",
      marginBottom: "10px",
    },
    name: {
      fontWeight: "bold",
      color: "#000",
    },
    product: {
      fontSize: "0.9em",
      color: "#444",
    },
    navButtons: {
      marginTop: "30px",
      display: "flex",
      gap: "10px",
    },
    navBtn: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      border: "1px solid #eee",
      fontSize: "1.2em",
      color: "#666",
      backgroundColor: "#fff",
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.leftColumn}>
        <h2 style={styles.heading}>{t("testimonials.heading")}</h2>
        <p style={styles.paragraph}>{t("testimonials.description")}</p>
        <div style={styles.navButtons}>
          {/* <button style={styles.navBtn}>❮</button> */}
          {/* <button style={styles.navBtn}>❯</button> */}
        </div>
      </div>

      <div style={styles.rightColumn}>
        {testimonials.map((tItem, index) => (
          <div key={index} style={styles.card}>
            <img src={tItem.img} alt={t(`testimonials.${tItem.key}.name`)} style={styles.avatar} />
            <p style={styles.text}>{t(`testimonials.${tItem.key}.text`)}</p>
            <div style={styles.stars}>{"★".repeat(tItem.stars)}</div>
            <div style={styles.name}>{t(`testimonials.${tItem.key}.name`)}</div>
            <div style={styles.product}>{t(`testimonials.${tItem.key}.product`)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
